import React, {useEffect, useState} from "react";
import PermitsLogo from "../../assets/permits-logo.png";
import HamburgerIcon from "../../assets/Hamburger.svg";
import {NavList} from "./nav-list.js";
import {useStateContext} from "../../helpers/state-context/use_state_context.js";

const mobileNavStyle = {
    flexDirection: 'column',
    position: 'absolute',
    width: '100%',
    top: 50,
    backgroundColor: 'rgba(255,255,255,.9)',
    zIndex: 500,
}

const mobileItemStyle = {
    padding: '8px 10px',
    textAlign: 'center'
};

const Header = function (props) {
    const [selectedPage,] = useState(4)
    const [active, setActive] = useState(false)
    const [state] = useStateContext(['renderSize']);
    const viewSize = ['xs', 'sm', 'md', 'lg'].includes(state.renderSize) ? 'small' : 'full';

    useEffect(() => {
        const handleClickOutside = (e) => {
            const container = document.getElementById('mobile-nav-list');

            if (container && !container.contains(e.target)) {
                // if the toggle is clicked, it will also trigger that event (which opens the menu again)
                // unless we stop propagation.
                e.stopPropagation();
                setActive(false)
            }
        };

        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        }
    }, []);


    return <header style={{
            height: 50,
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            justifyContent: 'space-between',
            borderBottom: '1px solid #eee',
            backgroundColor: '#ffffff'
        }}
    >
        <a href="https://www.permitsfoundation.com/" style={{display: 'block', height: '100%'}}> 
            <img src={PermitsLogo} style={{height: '100%', border: '0px none'}} alt={'logo'}/>
        </a>
        {
            (viewSize ==='small') ?
            <img src={HamburgerIcon} alt={'hamburger_icon'}
                 onClick={()=>setActive(prevState=>!prevState)}
                 style={{cursor: 'pointer', padding: 5}}/> :
            <NavList selected={selectedPage}/>
        }
        {(active && viewSize ==='small') ?
            <NavList id={'mobile-nav-list'}  selected={selectedPage} itemStyle={mobileItemStyle}
                     style={mobileNavStyle}/> :
            null}
    </header>
}

export {Header}